/**
 * use this file to register and export all API handler that will be used in the system
 **/

import type { InjectionKey } from 'vue';
import { PortalHeaderApi } from './portal-header-api';

export const portalHeaderApiKey: InjectionKey<PortalHeaderApi> = Symbol('portalHeaderApi');

/**
 * Provides global api's to be used within the application.
 *
 * @param baseUrl Base url of the api we are calling (portal backend)
 */
export default function useClientApi(baseUrl: string) {
	const nuxtApp = useNuxtApp();
	nuxtApp.vueApp.provide(portalHeaderApiKey, new PortalHeaderApi(baseUrl));
}

/**
 * Returns injected portal header api.
 * If there is no api provided, an error will be thrown.
 */
export function usePortalHeaderApi() {
	const portalHeaderApi = inject(portalHeaderApiKey);

	if (!portalHeaderApi) {
		throw new Error('portal header api not provided');
	}

	return portalHeaderApi;
}
